import * as React from 'react';
import { routeNode, IRouteNodeProps } from 'react-mobx-router5';

// Constants
import { ROUTE_PATHS, ROUTE_NAMES } from '../../constants/routes';

// Components
import AppIntro from '../AppIntro';
import AppNetwork from '../AppNetwork';
import Redirecter from './Redirecter';

// Component
export interface IProps extends IRouteNodeProps {
  openNetworkManager: () => void;
}

class Router extends React.Component<IProps> {
  render() {
    if (!this.props.route) {
      return <h1>Not Found</h1>;
    }
    const segment = this.props.route.name.split('.')[1];
    switch (segment) {
      case ROUTE_NAMES.APP_INTRO:
        return <AppIntro openNetworkManager={this.props.openNetworkManager} />;
      case ROUTE_NAMES.APP_NETWORK:
        return (
          <AppNetwork
            query={{ networkId: this.props.route!.params.networkId }}
          />
        );
      default:
        return <Redirecter />;
    }
  }
}

export default routeNode<IProps>(ROUTE_PATHS.APP)(Router);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/Router.tsx